import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { formatMoney } from 'utils/storefront/format-resource';

const CartItemPrice = ({ line, variant, isB2B }) => {
  if (!variant) return null;

  const [quantity, setQuantity] = useState(line.quantity);

  useEffect(() => {
    setQuantity(line.quantity);
  }, [line.quantity]);

  const compareAgainstRetailPrice = isB2B && variant?.retailPrice?.value > 0;
  const currencyCode = window.TMW?.localization?.currencyCode;

  const calculatePrice = (price, multiplier) => {

    if (!multiplier || !multiplier.value) {
      return {
        amount: price || 0,
        currencyCode: price?.currencyCode || currencyCode,
      };
    }
  
    const effectiveMultiplier = Math.max(
      quantity, parseInt(multiplier.value, 10) || 1
    );
    return {
      amount: effectiveMultiplier * (price || 0),
      currencyCode: price?.currencyCode || currencyCode,
    };
  };

  const price = () => {
    const className = compareAgainstRetailPrice
      ? 'text-dark-green ml-2'
      : variant.compareAtPrice
      ? 'text-red ml-2'
      : ''; 

    const effectivePrice = calculatePrice(line?.price, variant.sellInSets);

    return (
      <span className={`price ${className}`}>
        {effectivePrice.amount && (
          compareAgainstRetailPrice ? (
            `${formatMoney({
              amount: effectivePrice.amount / 100,
              currencyCode: effectivePrice.currencyCode,
            })} ${window.TMW.Strings.product.b2b}`
          ) : (
            formatMoney({
              amount: effectivePrice.amount / 100,
              currencyCode: effectivePrice.currencyCode,
            })
          )
        )}
      </span>
    );
  };

  const compareAtPrice = () => {
    const effectiveCompareAtPrice = variant.compareAtPrice
      ? calculatePrice(variant.compareAtPrice.amount, variant.sellInSets || 1)
      : null;

    const effectiveRetailPrice = compareAgainstRetailPrice
      ? calculatePrice(variant.retailPrice.value, variant.sellInSets || 1)
      : null;

    return (
      <span className="compareAtPrice">
        {compareAgainstRetailPrice && effectiveRetailPrice?.amount ? (
          <del>
            {formatMoney({
              amount: effectiveRetailPrice.amount,
              currencyCode: effectiveRetailPrice.currencyCode,
            })}
          </del>
        ) : effectiveCompareAtPrice?.amount ? (
          <del>
            {formatMoney({
              amount: effectiveCompareAtPrice.amount,
              currencyCode: effectiveCompareAtPrice.currencyCode,
            })}
          </del>
        ) : null}
      </span>
    );
  };

  return (
    <p className="utility-2">
      {compareAtPrice()}
      {price()}
    </p>
  );
};

export default CartItemPrice;
